import { CargoContractSides } from '@shared/utils/constants';
import type {
	CargoDetails,
	GetCargoDetailsResponse,
} from '@api/features/cargos/getCargoDetails';

export type ReletCargo = CargoDetails | GetCargoDetailsResponse;

export const isContractReletCargo = (cargo?: ReletCargo | null) => (
	cargo?.contractSide === CargoContractSides.VC_OUT ||
	cargo?.contractSide === CargoContractSides.VC_IN
);

export const getContractReletPair = ({
	cargoDetails,
	cargos,
}: {
	cargoDetails?: ReletCargo | null;
	cargos: ReletCargo[];
}) => {
	if (cargoDetails == null) {
		return {
			vcOutCargo: undefined,
			vcInCargo: undefined,
			hasCargoRelet: false,
		};
	}

	const allCargos = [cargoDetails, ...cargos];

	const vcOutCargo = 
		cargoDetails.contractSide === CargoContractSides.VC_IN ?
			allCargos.find((c) => (
				c.contractSide === CargoContractSides.VC_OUT &&
			(
				c.id === cargoDetails.reletCargoId ||
				c.reletCargoId === cargoDetails.id
			)
			)) :
			cargoDetails;

	const vcInCargo = 
		vcOutCargo == null ?
			undefined :
			allCargos.find((c) => (
				c.contractSide === CargoContractSides.VC_IN &&
			(
				c.reletCargoId === vcOutCargo.id ||
				c.id === vcOutCargo.reletCargoId
			)
			));

	return {
		vcOutCargo,
		vcInCargo,
		hasCargoRelet: vcOutCargo != null && vcInCargo != null,
	};
};